const validateDateTime = /^\d{4}(\/\d{1,2}){4}$/;
export function keyToDateTime(key) {
    if (key && validateDateTime.test(key)) {
        const date = key.split('/').map(i => +i);
        const time = { hour: date[3], minute: date[4] };
        date.length = 3;
        return { date: date, time };
    }
    return getDateTimeEmptyValue();
}
export function dateTimeToKey(dateTime) {
    if (!dateTime || !dateTime.date || !dateTime.time) {
        return '';
    }
    return `${dateTime.date[0]}/${dateTime.date[1]}/${dateTime.date[2]}/${dateTime.time.hour}/${dateTime.time.minute}`;
}
export function displayDateTime(stringDate, locale = 'en', hour12) {
    const dateTime = keyToDateTime(stringDate);
    if (!dateTime.date || !dateTime.time) {
        return '';
    }
    const formatter = new Intl.DateTimeFormat(locale, {
        month: 'short',
        year: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'UTC',
        hour12,
    });
    const formatedDate = formatter.format(new Date(Date.UTC(dateTime.date[0], dateTime.date[1] - 1, dateTime.date[2], dateTime.time.hour, dateTime.time.minute)));
    //This code fixes chrome bug (in some cases chrome displays 24 instead of 00)
    return formatedDate.replace('24:', '00:');
}
function dateTimeToDate(dateTime) {
    if (!dateTime.date) {
        throw Error('Wrong input parameter.');
    }
    return new Date(dateTime.date[0], dateTime.date[1] - 1, dateTime.date[2], dateTime.time.hour, dateTime.time.minute);
}
export function isValid(start, end) {
    if (!start !== !end ||
        !start ||
        !validateDateTime.test(start) ||
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !validateDateTime.test(end)) {
        return false;
    }
    const startArr = keyToDateTime(start);
    const date1 = dateTimeToDate(startArr);
    const endArr = keyToDateTime(end);
    const date2 = dateTimeToDate(endArr);
    return date1 < date2;
}
export function localeDateToLocaleMonth(localeDate) {
    return localeDate ? [localeDate[0], localeDate[1]] : undefined;
}
export function getDateTimeEmptyValue() {
    const date = new Date();
    return { date: undefined, time: { hour: date.getHours(), minute: date.getMinutes() } };
}
export function getCurrentLocaleDate() {
    const date = new Date();
    return [date.getFullYear(), (date.getMonth() + 1), date.getDate()];
}
